<template>
  <div class="accordion" @click="toggleOpen">
    <div class="month">
      <div class="label">{{ month.key }}の記録</div>
      <div class="arrow">
        <img :class="{ open: open }" src="@/assets/img/walk/arrow.png" />
      </div>
    </div>
    <div class="body" :class="{ open: open, close: !open }">
      <Histories :histories="month.histories" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Histories from './history'
import { FactoryTrack } from '@/constant/firebase'

export default {
  name: 'LoginBonusAccordion',
  props: ['month', 'index'],
  components: {
    Histories
  },
  data: function() {
    return {
      open: false
    }
  },
  async created() {
    // this.open = this.index === 0
  },
  mounted: function() {},
  beforeDestroy() {},
  computed: {},
  watch: {},
  methods: {
    ...mapActions('Analytics', ['trackEvent']),
    toggleOpen() {
      this.open = !this.open
      if (this.open) {
        this.trackEvent(FactoryTrack.createToggleOpen(`ログインボーナス ${this.month.key}の記録`))
      } else {
        this.trackEvent(FactoryTrack.createToggleClose(`ログインボーナス ${this.month.key}の記録`))
      }
      this.imageNumber = 1
    }
  }
}
</script>

<style lang="scss" scoped>
.histories {
  .month {
    background-color: #eeeeee;
    text-align: left;
    font-weight: bold;
    padding: 20px 10px;
    display: flex;
    border-bottom: 1px solid #e3e3e3;
    .label {
      flex: 1;
      color: #66160E;
      font-weight: bold;
    }
    .arrow {
      max-width: 10px;

      img {
        width: 100%;

        transition: all 0.35s;
        &.open {
          transform: rotate(180deg);
          transition: all 0.35s;
        }
      }
    }
  }
  .body {
    //max-height: 0;
    opacity: 0;
    overflow-y: hidden;
    transition: all 0.35s;
    &.close {
      height: 0;
      transition: all 0.35s;
    }
    &.open {
      opacity: 1;
      transition: all 0.35s;
    }
    .wrapper {
      align-items: baseline;
    }
  }
}
</style>
